module.exports = __webpack_public_path__ + "static/media/gotham-book.ce97af48.woff2";